import apiAnimals from "../config/api_animals";
// import axios from "axios";
import getHeaders from "./getHeaders";

// const apiAnimals = axios.create({
//   baseURL: "http://localhost:8084",
// });

export function indexAll(payload) {
  const { groupId, farmId } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/measurements`,
    getHeaders(false, null)
  );
}

export function findById(payload) {
  const { groupId, farmId, id } = payload;
  return apiAnimals.get(
    `/bovexo/${groupId}/farms/${farmId}/measurements/${id}`,
    getHeaders(false, null)
  );
}

export function save(payload) {
  const { groupId, farmId, body } = payload;
  return apiAnimals.post(
    `/bovexo/${groupId}/farms/${farmId}/measurements`,
    body,
    getHeaders(false, null)
  );
}

export function update(payload) {
  const { groupId, farmId, id, body } = payload;
  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/measurements/${id}`,
    body,
    getHeaders(false, null)
  );
}

export function inactivate(payload) {
  const { groupId, farmId, id } = payload;
  return apiAnimals.delete(
    `/bovexo/${groupId}/farms/${farmId}/measurements/${id}`,
    getHeaders(false, null)
  );
}

export function activate(payload) {
  const { groupId, farmId, id } = payload;
  return apiAnimals.patch(
    `/bovexo/${groupId}/farms/${farmId}/measurements/${id}/active`,
    null,
    getHeaders(false, null)
  );
}
